var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2399 7.02096C13.1585 7.02096 14.7075 5.4444 14.7075 3.50736C14.7075 1.56768 13.1585 0 11.2399 0C9.32139 0 7.77051 1.56768 7.77051 3.50736C7.77051 5.4444 9.32139 7.02096 11.2399 7.02096Z",
    fill: "#444F60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6138 7.875C16.2002 7.93164 16.8679 9.21684 16.8679 9.21684L21.9898 16.3228C22.2017 16.6379 22.3253 17.0236 22.3253 17.4397C22.3253 18.5447 21.4402 19.4418 20.347 19.4418C20.0854 19.4418 19.8475 19.3832 19.6217 19.2968L16.5298 18.4237V21.543H5.796V18.424L2.70384 19.2966C2.48592 19.3835 2.2404 19.442 1.97664 19.442C0.8832 19.442 0 18.5449 0 17.44C0 17.0236 0.12216 16.6376 0.34344 16.3225L5.46192 9.21684C5.46192 9.21684 6.13368 7.93164 7.71456 7.87524L14.6138 7.875ZM11.1641 19.365L15.1692 18.0196L15.0816 18.0018C12.3156 17.182 13.3906 13.4884 16.1503 14.3125L16.5302 14.4462V10.2774L11.1643 12.0486L5.796 10.2772V14.4452L6.174 14.3118C8.93832 13.4874 10.0152 17.181 7.2492 18.0008L7.1592 18.0193L11.1641 19.365Z",
    fill: "#444F60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6841,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.a1cba7b1a6eba6d0b75519a10e12e88f.svg";
export { ForwardRef as ReactComponent };